function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as modalActions } from '../../reducers/modal.reducer';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
import Confirm from '../common/modal/Confirm.modal';
var FormGroupDetails = function FormGroupDetails() {
  var _form$forms;
  var _useParams = useParams(),
    app = _useParams.app,
    formGroupID = _useParams.formGroupID;
  var dispatch = useDispatch();
  var hasPermission = useHasPermission("edit-".concat(app, "-forms"));
  var forms = useSelector(function (s) {
    return s.ppc.forms;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useEffect(function () {
    if (forms[formGroupID]) {
      setForm(forms[formGroupID]);
    }
  }, [app, formGroupID, forms]);
  var columns = {};
  var data = [];
  var groupTitle = form.groupTitle;
  columns = {
    id: {
      title: '_id',
      visible: false
    },
    slot: {
      title: 'slot',
      visible: false
    },
    title: {
      title: 'Form Title'
    },
    remove: {
      title: 'Remove',
      size: 'contain',
      onClick: function onClick(_ref) {
        var row = _ref.row;
        if (!hasPermission) return;
        dispatch({
          type: modalActions.show,
          payload: {
            component: /*#__PURE__*/React.createElement(Confirm, {
              onConfirm: function onConfirm() {
                dispatch({
                  type: ppcActions.forms,
                  payload: {
                    formData: {
                      groupID: formGroupID,
                      formID: row._id
                    },
                    method: 'delete',
                    route: 'form'
                  }
                });
              }
            })
          }
        });
      }
    }
  };
  data = (_form$forms = form.forms) === null || _form$forms === void 0 ? void 0 : _form$forms.map(function (x) {
    return {
      _id: x._id,
      title: x.title,
      slot: x.slot,
      remove: 'Remove'
    };
  });
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: groupTitle
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'slot'
    }
  }));
};
export default FormGroupDetails;